const mergeRoomPolicyNames = (packages = [], propertyData = []) => {
  const roomPolicies = [];
  const roomTypeDetails = propertyData.flatMap((property) => property?.room_types ?? []);

  for (const pkg of packages) {
    if (roomPolicies.some((roomPolicy) => roomPolicy.room_type_id === pkg.fk_room_type_id)) {
      continue;
    }

    const roomType = roomTypeDetails.find(
      (currentRoomType) => currentRoomType && currentRoomType.id === pkg.fk_room_type_id,
    );

    roomPolicies.push({
      id: pkg.fk_room_policy_id || null,
      salesforce_id: pkg.id_salesforce_external || null,
      room_type_id: pkg.fk_room_type_id,
      room_type_name: roomType?.name,
      description: pkg.room_policy_description || '',
      property_id: pkg.fk_property_id || null,
      room_rate_id: pkg.fk_room_rate_id || null,
      room_rate_ids: (roomType?.room_rates ?? []).map((roomRate) => roomRate.id),
    });
  }

  return roomPolicies;
};

export default mergeRoomPolicyNames;
